
<template>
    <div>
        <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
            <span class="mask bg-gradient-success opacity-8"></span>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">

                <div class="col-xl-12 order-xl-1">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0 text-capitalize">{{ replaceString(code) }}</h3>
                                </div>
                            </div>
                        </div>

                        <!-- import Payment Report template here -->
                        <PaymentReport
                            :privileges="privileges"
                            v-if="code && code == 'payment-report'"
                        />

                        <!-- import Application Report template here -->
                        <ApplicationReport
                            :privileges="privileges"
                            v-if="code && code == 'application-report'"
                        />

                        <!-- import Audit Trails template here -->
                        <AuditTrails
                            :privileges="privileges"
                            v-if="code && code == 'audit-trails'"
                        />

                        <!-- import Doctor Profile Report template here -->
                        <DoctorProfileReport
                            :privileges="privileges"
                            v-if="code && code == 'doctor-profile-report'"
                        />

                        <!-- import Doctor Profile Report template here -->
                        <ComplaintsReport
                            :privileges="privileges"
                            v-if="code && code == 'complaints-report'"
                        />

                        <!-- import sanction Profile Report template here -->
                        <SanctionReport
                            :privileges="privileges"
                            v-if="code && code == 'sanction-report'"
                        />

                        <!-- import quack reports reporting template here -->
                        <QuackReports
                            :privileges="privileges"
                            v-if="code && code == 'quack-reports-reporting'"
                        />

                        <!-- import quacks reporting template here -->
                        <Quacks
                            :privileges="privileges"
                            v-if="code && code == 'quacks-reporting'"
                        />

                        <!-- import Medical Education Report template here -->
                        <MedicalEducationReport
                            :privileges="privileges"
                            v-if="code && code == 'medical-education-reporting'"
                        />

                    </card>
                </div>
            </div>

        </div>

    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import PaymentReport from './PaymentReport/PaymentReport';
    import ApplicationReport from './ApplicationReport/ApplicationReport';
    import AuditTrails from './AuditTrails/AuditTrails';
    import DoctorProfileReport from './DoctorProfileReport/DoctorProfileReport';
    import ComplaintsReport from './ComplaintsReport/ComplaintsReport.vue';
    import SanctionReport from './SanctionReport/SanctionReport.vue';
    import QuackReports from './QuackReports/QuackReports.vue';
    import Quacks from './Quacks/Quacks.vue';
    import MedicalEducationReport from './MedicalEducationReport/MedicalEducationReport.vue';

    export default {
        name: 'Reporting',
        components: {
            PaymentReport,
            ApplicationReport,
            AuditTrails,
            DoctorProfileReport,
            ComplaintsReport,
            SanctionReport,
            QuackReports,
            Quacks,
            MedicalEducationReport
        },
        data() {
        return {
            code: this.$route.params.code,
        }
        },
        computed: {
            ...mapGetters(['menus']),
            privileges() {
            let privileges = null;
            if(this.menus && this.menus.length > 0) {
                for(let menu of this.menus) {
                    if(menu.has_child && menu.has_child.length > 0) {
                        for(let child of menu.has_child) {
                            if('/'+child.link == this.$route.path) {
                                privileges = child.privileges;
                            }
                        }
                    }
                }
            }
            return privileges;
            }
        },
        methods: {
            replaceString(value) {
                let text = value.replace('-', ' ');
                return value ? text.replace('-', ' ') : 'Reporting';
            }
        }
    };
</script>
<style scoped>
</style>
